module.exports = __webpack_public_path__ + "img/bg_court_05.bb8dde85.jpg";